<template>
  <div>
    <b-row>
      <b-container>
        <h1 class="text-center py-2">
          {{ labels.title }}
        </h1>
      </b-container>
    </b-row>
    <b-row>
      <b-container>
        <h4 class="text-center border-bottom">
          {{ labels.subtitle }}
        </h4>
        <b-col md="8" class="mx-auto">
          <ul>
            <li v-for="(item, idx) in labels.instructive" :key="idx">
              {{ item }}
            </li>
          </ul>
        </b-col>
      </b-container>
    </b-row>
    <b-row v-if="!isLoading">
      <b-container>
        <b-col md="10" class="mx-auto">
          <b-button @click="goToCreateBalance()" id="create-btn">
            {{ labels.create }}
          </b-button>
        </b-col>
      </b-container>
      <b-container v-if="!isEmpty" class="pb-5">
        <h4 class="text-center">
          {{ labels.info }}
        </h4>
        <b-col md="12" class="mx-auto">
          <md-field>
            <md-select v-model="yearSelected" @md-selected="yearSelect">
              <md-option
                v-for="item in arrYear"
                v-bind:key="item"
                :value="item">
                {{ item }}
              </md-option>
            </md-select>
          </md-field>

          <md-table
            v-model="balanceSearched"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            md-card>
            <md-table-row>
              <md-table-head>{{labels.month}}</md-table-head>
              <md-table-head> {{ labels.cantidadSacos }} </md-table-head>
              <md-table-head> {{ labels.trm }} </md-table-head>
              <md-table-head> {{ labels.portuarios }} </md-table-head>
              <md-table-head> {{ labels.transporte }} </md-table-head>
              <md-table-head> {{ labels.seguros }} </md-table-head>
              <md-table-head> {{ labels.seryemp }} </md-table-head>
              <md-table-head> {{ labels.reliquidaciones }} </md-table-head>
              <md-table-head> {{ labels.intereses }} </md-table-head>
              <md-table-head> {{ labels.comisiones }} </md-table-head>
              <md-table-head> {{ labels.cuatropor }} </md-table-head>
              <md-table-head> {{ labels.overhead }} </md-table-head>
              <md-table-head> {{ labels.costodecaf }} </md-table-head>
            </md-table-row>

            <md-table-row v-for="(item,idx) in balanceSearched" :key="idx">

              <md-table-cell
                :md-label="labels.month">
                {{ monthList[parseFloat(item.month)-1] }}
              </md-table-cell>

              <md-table-cell
                :md-label="labels.cantidadSacos">
                {{ thoSeparator(item.cantidadSacos) }}
              </md-table-cell>

              <md-table-cell
                :md-label="labels.trm">
                {{ thoSeparator(item.trm) }}
              </md-table-cell>

              <md-table-cell
                :md-label="labels.portuarios">
                {{ thoSeparator(item.portuarios) }}
              </md-table-cell>

              <md-table-cell
                :md-label="labels.transporte" >
                {{ thoSeparator(item.transporte) }}
              </md-table-cell>

              <md-table-cell
                :md-label="labels.seguros">
                {{ thoSeparator(item.seguros) }}
              </md-table-cell>

              <md-table-cell
                :md-label="labels.seryemp">
                {{ thoSeparator(item.empaqueyservicios) }}
              </md-table-cell>

              <md-table-cell
                :md-label="labels.reliquidaciones">
                {{ thoSeparator(item.reliquidacionesflo) }}
              </md-table-cell>

              <md-table-cell
                :md-label="labels.intereses">
                {{ thoSeparator(item.intereses) }}
              </md-table-cell>

              <md-table-cell
                :md-label="labels.comisiones">
                {{ thoSeparator(item.comisiones) }}
              </md-table-cell>

              <md-table-cell
                :md-label="labels.cuatropor">
                {{ thoSeparator(item.cuatropormil) }}
              </md-table-cell>

              <md-table-cell
                :md-label="labels.overhead">
                {{ thoSeparator(item.overhead) }}
              </md-table-cell>

              <md-table-cell
                :md-label="labels.costodecaf">
                {{ thoSeparator(item.costodecaf) }}
              </md-table-cell>

            </md-table-row>
          <md-table-row>
              <md-table-cell></md-table-cell>
              <md-table-cell> {{ thoSeparator(totals.cantidadSacos) }} </md-table-cell>
              <md-table-cell> {{ thoSeparator(totals.trm) }} </md-table-cell>
              <md-table-cell> {{ thoSeparator(totals.portuarios) }} </md-table-cell>
              <md-table-cell> {{ thoSeparator(totals.portuarios) }} </md-table-cell>
              <md-table-cell> {{ thoSeparator(totals.seguros) }} </md-table-cell>
              <md-table-cell> {{ thoSeparator(totals.empaqueyservicios) }} </md-table-cell>
              <md-table-cell> {{ thoSeparator(totals.reliquidacionesflo) }} </md-table-cell>
              <md-table-cell> {{ thoSeparator(totals.intereses) }} </md-table-cell>
              <md-table-cell> {{ thoSeparator(totals.comisiones) }} </md-table-cell>
              <md-table-cell> {{ thoSeparator(totals.cuatropormil) }} </md-table-cell>
              <md-table-cell> {{ thoSeparator(totals.overhead) }} </md-table-cell>
              <md-table-cell> {{ thoSeparator(totals.costodecaf) }} </md-table-cell>
            </md-table-row>
          </md-table>
        </b-col>
        <b-col
          md="6"
          class="mx-auto empty-table pt-4"
          v-if="searched.length == 0 && balances.length > 0 && !isLoading"
        >
          <h3>{{ labels.notFound }}</h3>
          <p>
            {{ labels.notFoundMessage }}: <span>{{ search }}</span>
          </p>
        </b-col>
      </b-container>
      <b-container v-else>
        <b-col md="2" class="mx-auto">
          <div class="success-svg mb-4" :class="{ active: isEmpty }">
            <img src="../../assets/imgs/file-2.svg" alt="warning" />
          </div>
        </b-col>
        <b-col md="12" class="justify-content-around">
          <span id="message" v-if="isEmpty">{{ labels.empty }}</span>
        </b-col>
      </b-container>
    </b-row>
    <b-row v-else>
      <b-col md="12" lg="12" class="p-4 mx-audo">
        <div class="text-center">
          <b-spinner></b-spinner>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Balance from "@/services/Balance";

const toLower = (text) => {
  return text.toString().toLowerCase();
};

const searchByLocated = (items, term) => {
  if (term) {
    return items.filter((item) => toLower(item.name).includes(toLower(term)));
  }

  return items;
};

export default {
  name: "List",

  data: () => ({
    currentSort: "createdAt",
    currentSortOrder: "asc",
    balances: [],
    searched: [],
    arrYear: [],
    objBalance: {},
    search: null,
    isEmpty: false,
    isUpdating: false,
    isLoading: false,
    success: false,
    error: false,
    yearSelected: "2021",
    balanceSearched: {},
    filename: "List.xls",
    monthList: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
  }),
  computed: {
    totals(){
      var total1 = {};
      for (var i=0; i<this.balanceSearched.length; i++){
          Object.entries(this.balanceSearched[i]).forEach(([key, value]) => {
            total1[key] = parseFloat(total1[key]||0)+parseFloat(value||0);
          });
      }
      return total1
    },
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          title: "Administra las liquidaciones que se han cargado",
          subtitle: "Instrucciones",
          instructive: [
            "En esta página puedes visualizar y cargar liquidaciones",
          ],
          info: "Información General",
          search: "Buscar por responsable",
          empty: "Aún no cuentas con liquidaciones",
          create: "Nuevo",
          notFound: "No Hay compañias",
          notFoundMessage: "No hay compañias con ese nombre",
          portuarios: "Portuarios",
          transporte: "Transporte",
          seguros: "Seguros",
          seryemp: "Servicios y Empaque",
          reliquidaciones: "Reliquidaciones FLO",
          intereses: "Intereses",
          comisiones: "Comisiones",
          cuatropor: "Cuatro por Mil",
          overhead: "Overhead",
          costodecaf: "Costo de Café",
          month: "Mes",
          trm: "TRM mes",
          cantidadSacos: "Sacos exportados"
        };
      } else {
        return {
          title: "Companies Management Platform",
          subtitle: "Instructions",
          instructive: [
            "Welcome to the platform for the visualization and creation of companies",
          ],
          info: "General Information",
          search: "Search by name",
          createdDate: "Created Date",
          name: "Balance Name",
          email: "Email",
          empty: "You don't have invoices yet",
          create: "Create",
          notFound: "Not Found",
          notFoundMessage: "No companies found with that name",
        };
      }
    },
  },
  methods: {
    thoSeparator(value){
      return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    yearSelect() {
      this.balanceSearched = this.objBalance[this.yearSelected];
    },
    goToCreateBalance() {
      this.$router.push({ path: "/balance/create" });
    },
    deleteBalance(id) {
      this.isLoading = true;
      Balance.deleteBalance(id).then(() => {
        this.isLoading = false;
      });
      this.balances = this.balances.filter((Balance) => Balance.id != id);
      this.searched = this.balances;
    },
    customSort(value) {
      // console.log(value);
      return value.sort((a, b) => {
        const sortBy = this.currentSort;

        if (this.currentSortOrder === "desc") {
          return a[sortBy].toString().localeCompare(b[sortBy].toString());
        }

        return b[sortBy].toString().localeCompare(a[sortBy].toString());
      });
    },
    searchOnTable() {
      this.searched = searchByLocated(this.balances, this.search);
    },
  },
  mounted() {
    this.isLoading = true;
    Balance.getAllBalance(this.$store.state.userName)
      .then((result) => {
        // console.log(result.data)
        this.balances = result.data.balances;
        this.searched = this.balances;
        if (this.balances.length == 0) {
          this.isEmpty = true;
        }
        var miArr = [];
        for (var i = 0; i < this.searched.length; i++) {
          miArr[i] = this.searched[i].year;
        }
        this.arrYear = [...new Set(miArr)];

        for (i = 0; i < this.arrYear.length; i++) {
          var actualKey = this.arrYear[i].toString();
          var count = 0;
          let arrBalance = [];
          for (var j = 0; j < this.searched.length; j++) {
            if (this.searched[j].year == actualKey) {
              arrBalance[count] = this.searched[j];
              count = count + 1;
            }
          }
          this.objBalance[actualKey] = arrBalance;
        }
        this.balanceSearched = this.objBalance[this.yearSelected];
      })
      .catch(() => {
        // console.log(error);
        this.error = true;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
};
</script>

<style src="../main.css"></style>
